import { useLocation, useNavigate } from "react-router-dom";
import { Plus, ArrowUpRight, CreditCard, RussianRuble } from "lucide-react";
import { useApp } from "@/App";
import { useTranslation } from "react-i18next";

const WithdrawCryptoIcon = ({ className }) => (
  <div className="relative w-full h-full flex items-center justify-center">
    <ArrowUpRight className="w-7 h-7" />
  </div>
);

const WithdrawRubIcon = ({ className }) => (
  <div className="relative w-full h-full flex items-center justify-center">
    <ArrowUpRight className="w-7 h-7" />
    {/* Значок валюты сидит на акценте продукта, а не на своём голубом:
        двух синих в одном ряду кнопок быть не должно. */}
    <div className="absolute -right-1 -bottom-1 bg-primary rounded-full w-5 h-5 flex items-center justify-center z-10 ring-1 ring-white/60">
      <RussianRuble className="w-3 h-3 text-primary-foreground" />
    </div>
  </div>
);

export const QuickActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { haptic } = useApp();
  const soonTextRaw = t('topup.soon') || 'Скоро';
  const soonText = soonTextRaw ? soonTextRaw.charAt(0).toUpperCase() + soonTextRaw.slice(1) : 'Скоро';

  const actions = [
    {
      id: "topup",
      labelKey: "actions.topup",
      icon: () => <Plus className="w-7 h-7" />,
      path: "/topup",
      // Единственное первичное действие ряда. Четыре одинаково залитых
      // кнопки означают, что первичной нет ни одной.
      primary: true
    },
    {
      id: "withdraw_crypto",
      labelKey: "actions.withdraw_crypto",
      icon: WithdrawCryptoIcon,
      path: "/send?tab=crypto"
    },
    {
      id: "withdraw_rub",
      labelKey: "actions.withdraw_rub",
      icon: WithdrawRubIcon,
      path: "/send?tab=fiat"
    },
    {
      id: "cards",
      // Свой ключ, а не общий services.cards: тот же ключ носит «Выдача
      // наличных» на экране сервисов, и переименование задело бы её.
      labelKey: "services.foreign_cards",
      icon: () => <CreditCard className="w-7 h-7" />,
      path: "/cards",
      maintenance: true
    },
  ];

  const location = useLocation();

  const handleAction = (path) => {
    if (!path) return;
    haptic('medium');
    // Запоминаем, откуда зашли: в раздел карт ведут два разных экрана, и
    // «назад» обязан вернуть человека на тот, с которого он пришёл, а не на
    // один и тот же зашитый.
    navigate(path, { state: { from: location.pathname + location.search } });
  };

  return (
    <div className="quick-actions !gap-0 flex-nowrap justify-between px-2" data-testid="quick-actions">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.id}
            onClick={() => handleAction(action.path)}
            disabled={action.disabled}
            className={`action-btn w-1/4 flex flex-col items-center ${action.primary ? 'action-btn--primary' : ''} ${action.disabled ? 'opacity-70 cursor-not-allowed' : ''}`}
            data-testid={`action-${action.id}`}
          >
            <div className="action-btn-icon mb-1 relative">
              <Icon className="" />
              {action.soon && (
                <span className="absolute -right-2 -top-2 rounded-full bg-[var(--lp-tile)] px-1.5 py-0.5 text-[8px] font-semibold text-muted-foreground">
                  {soonText}
                </span>
              )}
            </div>
            <span className="action-btn-label text-[9px] leading-[1.2] whitespace-pre-line text-center w-full min-h-[2.4em] flex items-start justify-center px-0.5">
              {t(action.labelKey)}
            </span>
            {action.maintenance && (
              <span data-testid="cards-maintenance-badge" className="mt-1 rounded-md px-1.5 py-1 text-[10px] font-bold leading-tight text-center" style={{ background: "#fef3c7", color: "#78350f", border: "1px solid #f59e0b" }}>
                {t("cards.maintenance_badge")}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default QuickActions;
